export const nomenclatureConstants = {
    COUNTRY_REQUEST: 'CONTRY_GETALL_REQUEST',
    COUNTRY_SUCCESS: 'CONTRY_GETALL_SUCCESS',
    COUNTRY_FAILURE: 'CONTRY_GETALL_FAILURE',

    COUNTRYAGREEMENT_REQUEST: 'COUNTRYAGREEMENT_GET_REQUEST',
    COUNTRYAGREEMENT_SUCCESS: 'COUNTRYAGREEMENT_GET_SUCCESS',
    COUNTRYAGREEMENT_FAILURE: 'COUNTRYAGREEMENT_GET_FAILURE',   


    CATEGORYDOCENT_REQUEST: 'CATEGORYDOCENT_GETALL_REQUEST',
    CATEGORYDOCENT_SUCCESS: 'CATEGORYDOCENT_GETALL_SUCCESS',
    CATEGORYDOCENT_FAILURE: 'CATEGORYDOCENT_GETALL_FAILURE',

    UNIVERSITIES_REQUEST: 'UNIVERSITIES_DELETE_REQUEST',
    UNIVERSITIES_SUCCESS: 'UNIVERSITIES_DELETE_SUCCESS',
    UNIVERSITIES_FAILURE: 'UNIVERSITIES_DELETE_FAILURE'    
};